enum EnumDocumentType {
	Csv = 0,
	Pdf = 1
}
export default EnumDocumentType
